module.exports = __webpack_public_path__ + "static/media/consulting-service-img.2361326e.png";